module.exports = __webpack_public_path__ + "static/browser_yamaha-1aa152dbaf3c7967bbe370aebe21408c.png";